var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-by-selector"},_vm._l((_vm.buttonsOptions),function(button){return _c('v-btn',{key:button.value,staticClass:"gb-tab",class:{ active: button.value === _vm.currentGroupBy },attrs:{"text":"","depressed":""},on:{"click":function($event){_vm.currentGroupBy = button.value}}},[_vm._v(" "+_vm._s(button.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }